import React, { FC } from "react";
import { Button } from "../../ActionsSelectors/Button";
import { IPromoWidgetProps } from "./PromoWidget.interface";

export interface IPromoWidgetActionsProps
  extends Pick<IPromoWidgetProps, "id" | "link" | "actions" | "type"> {
  classes?: {
    root?: string;
  };
}

const PromoWidgetActions: FC<IPromoWidgetActionsProps> = ({
  id,
  link,
  actions,
  classes,
  type,
}) => (
  <div className={`btn-group ${classes?.root || ""}`}>
    {actions.map(({ onClick, ...action }) => {
      const clickHandler = (e) => {
        if (onClick) {
          e.preventDefault();
          e.stopPropagation();
          onClick({ id, action, link });
        }
      };
      return (
        <Button
          key={action.text}
          data-testid="PromoWidgetActions__button"
          variant={type === "default" ? "primary" : "secondary"}
          classes={{ root: "mb-4 me-4 white-space-nowrap" }}
          onClickCapture={clickHandler}
          {...action}
        >
          {action.text}
        </Button>
      );
    })}
  </div>
);

export default PromoWidgetActions;
